import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { languages } from '../languages';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { filterHalalRecipes, filterHalalIngredients, filterHalalAreas } from '../utils/halalFilter';

import { Typography, Card, CardBody, IconButton, Alert } from "@material-tailwind/react";
import {
    ClockIcon,
    UserGroupIcon,
    FireIcon,
    HeartIcon,
    XMarkIcon,
    ChevronRightIcon,
    ArrowDownTrayIcon
} from "@heroicons/react/24/outline";
import { generateRecipePdf } from '../utils/generateRecipePdf';
import { resolveImageUrl } from '../utils/imageUrl';
import { isMaisterchefGermanTheme, mcDePageClass } from '../utils/branding';
import { HeartIcon as HeartIconSolid } from "@heroicons/react/24/solid";
import RecipeDetail from './RecipeDetail';

import Chicken from '../assets/images/ingredients/chicken.png';
import Beef from '../assets/images/ingredients/beef.png';
import Pork from '../assets/images/ingredients/pork.png';
import Salmon from '../assets/images/ingredients/salmon.png';
import Shrimp from '../assets/images/ingredients/shrimp.png';
import Eggs from '../assets/images/ingredients/eggs.png';
import Tofu from '../assets/images/ingredients/tofu.png';
import Tuna from '../assets/images/ingredients/tuna.png';
import Potato from '../assets/images/ingredients/potato.png';
import Rice from '../assets/images/ingredients/rice.png';
import Point from '../assets/images/point.png';
import Drop from '../assets/images/drop.png';

import MasteringtheArtofFrenchCooking from '../assets/images/cookbooks/MasteringtheArtofFrenchCooking.jpg';
import TheJoyofCooking from '../assets/images/cookbooks/TheJoyofCooking.jpg';
import SaltFatAcidHeat from '../assets/images/cookbooks/SaltFatAcidHeat.jpg';
import TheSilverSpoon from '../assets/images/cookbooks/TheSilverSpoon.jpg';
import HowtoCookEverything from '../assets/images/cookbooks/HowtoCookEverything.jpg';
import OttolenghiTheCookbook from '../assets/images/cookbooks/OttolenghiTheCookbook.jpg';
import Plenty from '../assets/images/cookbooks/Plenty.jpg';
import Jerusalem from '../assets/images/cookbooks/Jerusalem.jpg';
import TheBarefootContessaCookbook from '../assets/images/cookbooks/TheBarefootContessaCookbook.jpg';
import EssentialsofClassicItalianCooking from '../assets/images/cookbooks/EssentialsofClassicItalianCooking.jpg';
import TheFlavorBible from '../assets/images/cookbooks/TheFlavorBible.jpg';
import VegetablesUnleashed from '../assets/images/cookbooks/VegetablesUnleashed.jpg';
import Momofuku from '../assets/images/cookbooks/Momofuku.jpg';
import TheFrenchLaundryCookbook from '../assets/images/cookbooks/TheFrenchLaundryCookbook.jpg';
import TheSmittenKitchenCookbook from '../assets/images/cookbooks/TheSmittenKitchenCookbook.jpg';
import MagnoliaTable from '../assets/images/cookbooks/MagnoliaTable.jpg';
import TheArtofSimpleFood from '../assets/images/cookbooks/TheArtofSimpleFood.jpg';
import TheIndianCookingCourse from '../assets/images/cookbooks/TheIndianCookingCourse.jpg';
import MexicanEveryday from '../assets/images/cookbooks/MexicanEveryday.jpg';
import NopiTheCookbook from '../assets/images/cookbooks/NopiTheCookbook.jpg';

// Spanish cookbooks
const spanishCookbooks = [
    {
        name: '30 postres caseros',
        author: 'Javier Romero',
        image: '/cookbooks/es/30-postres-caseros.jpg',
        pdfUrl: '/cookbooks/es/30-postres-caseros.pdf'
    },
    {
        name: 'Cocina fácil en tiempos difíciles',
        author: 'Jesús y Teresita Gutiérrez',
        image: '/cookbooks/es/cocina-facil-en-tiempos-dificiles-jesus-y-teresita-gutierrez.jpg',
        pdfUrl: '/cookbooks/es/cocina-facil-en-tiempos-dificiles-jesus-y-teresita-gutierrez.pdf'
    },
    {
        name: 'Cocina regional española',
        author: 'Amiloquemegustaescocinar',
        image: '/cookbooks/es/cocina-regional-espanola-presentacion-autor-amiloquemegustaescocinar.jpg',
        pdfUrl: '/cookbooks/es/cocina-regional-espanola-presentacion-autor-amiloquemegustaescocinar.pdf'
    },
    {
        name: 'Guía de técnicas culinarias',
        author: 'Asociación de Chefs del Ecuador',
        image: '/cookbooks/es/guia-de-tecnicas-culinarias-asociacion-de-chefs-del-ecuador.jpg',
        pdfUrl: '/cookbooks/es/guia-de-tecnicas-culinarias-asociacion-de-chefs-del-ecuador.pdf'
    },
    {
        name: 'Más creatividad, mejor nutrición',
        author: 'Gobierno de Argentina',
        image: '/cookbooks/es/mas-creatividad-mejor-nutricion-agricultura-ganaderia-y-pesca-gobierno-de-argentina.jpg',
        pdfUrl: '/cookbooks/es/mas-creatividad-mejor-nutricion-agricultura-ganaderia-y-pesca-gobierno-de-argentina.pdf'
    },
    {
        name: 'Paella Party',
        author: 'Zingerman\'s Deli',
        image: '/cookbooks/es/paella-party-ingles-autor-zingermans-deli.jpg',
        pdfUrl: '/cookbooks/es/paella-party-ingles-autor-zingermans-deli.pdf'
    },
    {
        name: 'Principios de cocina II',
        author: 'Romano Segrado',
        image: '/cookbooks/es/principios-de-cocina-ii.jpg',
        pdfUrl: '/cookbooks/es/principios-de-cocina-ii.pdf'
    },
    {
        name: 'Recetario Madrileño',
        author: 'Amas de Casa - EsMadrid',
        image: '/cookbooks/es/recetario-madrilenoo-amas-de-casa-autor-esmadrid.jpg',
        pdfUrl: '/cookbooks/es/recetario-madrilenoo-amas-de-casa-autor-esmadrid.pdf'
    },
    {
        name: 'Recetario Vegano con platos peruanos',
        author: 'ARBA',
        image: '/cookbooks/es/recetario-vegano-platos-peruanos.jpg',
        pdfUrl: '/cookbooks/es/recetario-vegano-platos-peruanos.pdf'
    },
    {
        name: 'Recetas Económicas',
        author: 'De Rechupete',
        image: '/cookbooks/es/recetas-economicas-de-rechupete.jpg',
        pdfUrl: '/cookbooks/es/recetas-economicas-de-rechupete.pdf'
    },
    {
        name: 'Recetas Vegetarianas',
        author: 'Igualdad Animal',
        image: '/cookbooks/es/recetas-vegetarianas.jpg',
        pdfUrl: '/cookbooks/es/recetas-vegetarianas.pdf'
    },
    {
        name: 'Sevilla gastronómica',
        author: 'Turismo de Sevilla',
        image: '/cookbooks/es/sevilla-gastronomica-autor-turismo-de-sevilla.jpg',
        pdfUrl: '/cookbooks/es/sevilla-gastronomica-autor-turismo-de-sevilla.pdf'
    },
    {
        name: 'Un viaje por los arroces de España',
        author: 'Unilever Food Solutions',
        image: '/cookbooks/es/un-viaje-por-los-arroces-de-espana-autor-unilever-food-solutions.jpg',
        pdfUrl: '/cookbooks/es/un-viaje-por-los-arroces-de-espana-autor-unilever-food-solutions.pdf'
    },
    {
        name: 'Viaje Culinario por España',
        author: 'Centro Cultural de España',
        image: '/cookbooks/es/viaje-culinario-por-espana-autor-centro-culttural-de-espana.jpg',
        pdfUrl: '/cookbooks/es/viaje-culinario-por-espana-autor-centro-culttural-de-espana.pdf'
    }
];

// Default cookbooks for other languages
const popularCookbooks = [
    { name: 'Mastering the Art of French Cooking', author: 'Julia Child, Louisette Bertholle, Simone Beck', image: MasteringtheArtofFrenchCooking },
    { name: 'The Joy of Cooking', author: 'Irma S. Rombauer', image: TheJoyofCooking },
    { name: 'Salt, Fat, Acid, Heat', author: 'Samin Nosrat', image: SaltFatAcidHeat },
    { name: 'The Silver Spoon', author: 'The Italian Academy of Cuisine', image: TheSilverSpoon },
    { name: 'How to Cook Everything', author: 'Mark Bittman', image: HowtoCookEverything },
    { name: 'Ottolenghi: The Cookbook', author: 'Yotam Ottolenghi & Sami Tamimi', image: OttolenghiTheCookbook },
    { name: 'Plenty', author: 'Yotam Ottolenghi', image: Plenty },
    { name: 'Jerusalem', author: 'Yotam Ottolenghi & Sami Tamimi', image: Jerusalem },
    { name: 'The Barefoot Contessa Cookbook', author: 'Ina Garten', image: TheBarefootContessaCookbook },
    { name: 'Essentials of Classic Italian Cooking', author: 'Marcella Hazan', image: EssentialsofClassicItalianCooking },
    { name: 'The Flavor Bible', author: 'Karen Page & Andrew Dornenburg', image: TheFlavorBible },
    { name: 'Vegetables Unleashed', author: 'José Andrés', image: VegetablesUnleashed },
    { name: 'Momofuku', author: 'David Chang & Peter Meehan', image: Momofuku },
    { name: 'The French Laundry Cookbook', author: 'Thomas Keller', image: TheFrenchLaundryCookbook },
    { name: 'The Smitten Kitchen Cookbook', author: 'Deb Perelman', image: TheSmittenKitchenCookbook },
    { name: 'Magnolia Table', author: 'Joanna Gaines', image: MagnoliaTable },
    { name: 'The Art of Simple Food', author: 'Alice Waters', image: TheArtofSimpleFood },
    { name: 'The Indian Cooking Course', author: 'Monisha Bharadwaj', image: TheIndianCookingCourse },
    { name: 'Mexican Everyday', author: 'Rick Bayless', image: MexicanEveryday },
    { name: 'Nopi: The Cookbook', author: 'Yotam Ottolenghi & Ramael Scully', image: NopiTheCookbook }
];


const Home = () => {
    const [savedRecipes, setSavedRecipes] = useState([]);
    const [selectedRecipe, setSelectedRecipe] = useState(null);
    const [selectedImageData, setSelectedImageData] = useState(null);
    const [isDetailDialogOpen, setIsDetailDialogOpen] = useState(false);
    const [recipesByLetter, setRecipesByLetter] = useState([]);
    const [selectedLetter, setSelectedLetter] = useState(null);
    const [loadingRecipes, setLoadingRecipes] = useState(false);
    const [allRecipes, setAllRecipes] = useState([]);
    const [displayedCount, setDisplayedCount] = useState(20);
    const [categories, setCategories] = useState([]);
    const [ingredients, setIngredients] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedIngredient, setSelectedIngredient] = useState(null);
    const [filterType, setFilterType] = useState('letter'); // 'letter', 'category', 'ingredient', 'area'
    const [areas, setAreas] = useState([]);
    const [selectedArea, setSelectedArea] = useState(null);
    const [randomRecipes, setRandomRecipes] = useState([]);
    const [showRandomRecipes, setShowRandomRecipes] = useState(true);
    const [showVideos, setShowVideos] = useState(false);
    const [showRecipeLibrary, setShowRecipeLibrary] = useState(true);
    const [recipeLibraryRecipes, setRecipeLibraryRecipes] = useState([]);
    const [selectedRecipeLibraryFilter, setSelectedRecipeLibraryFilter] = useState(null);
    const [recipeLibraryFilterType, setRecipeLibraryFilterType] = useState(null);
    const [loadingRecipeLibrary, setLoadingRecipeLibrary] = useState(false);
    const [selectedRecipeLibrary, setSelectedRecipeLibrary] = useState(null);
    const [isRecipeLibraryDialogOpen, setIsRecipeLibraryDialogOpen] = useState(false);
    const [randomRecipeLibraryRecipes, setRandomRecipeLibraryRecipes] = useState([]);
    const [showRandomRecipeLibrary, setShowRandomRecipeLibrary] = useState(true);
    const [allRecipeLibraryRecipes, setAllRecipeLibraryRecipes] = useState([]);
    const [displayedRecipeLibraryCount, setDisplayedRecipeLibraryCount] = useState(6);
    const [hasLoadedInitialRecipes, setHasLoadedInitialRecipes] = useState(false);
    const [loadingRandomRecipes, setLoadingRandomRecipes] = useState(false);
    const [loadingRecipeLibraryCount, setLoadingRecipeLibraryCount] = useState(0);

    // New state for database recipes (Library 1)
    const [databaseRecipes, setDatabaseRecipes] = useState([]);
    const [loadingDatabaseRecipes, setLoadingDatabaseRecipes] = useState(false);
    const [databaseRecipeFilters, setDatabaseRecipeFilters] = useState({
        search: '',
        letter: '',
        maxCalories: '1000',
        maxCookingTime: '120',
        minServings: '1',
        maxServings: '12',
        allergens: [],
        ingredients: []
    });
    const [filteredDatabaseRecipes, setFilteredDatabaseRecipes] = useState([]);
    const [availableIngredients, setAvailableIngredients] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [sortBy, setSortBy] = useState('random');

    const API_BASE_URL = '/api'; // Adjust this to your backend URL

    // Use ref to prevent double loading in React Strict Mode
    const hasInitialized = useRef(false);
    const randomRecipesRef = useRef([]);

    const { language } = useLanguage();
    const mcDeTheme = isMaisterchefGermanTheme(language);

    // Map Belgian language codes to french and nederlands for translations
    // But keep the language code for API calls
    let translationLanguage = language;
    if (language === 'befr' || language === 'be-fr') {
        translationLanguage = 'french';
    } else if (language === 'benl' || language === 'be-nl') {
        translationLanguage = 'nederlands';
    } else if (language === 'bh-ar' || language === 'bahrain-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'bh-en' || language === 'bahrain-english') {
        translationLanguage = 'english';
    } else if (language === 'uae-ar' || language === 'uae-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'uae-en' || language === 'uae-english') {
        translationLanguage = 'english';
    } else if (language === 'sa-ar' || language === 'sa-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'sa-en' || language === 'sa-english') {
        translationLanguage = 'english';
    } else if (language === 'kw-ar' || language === 'kw-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'kw-en' || language === 'kw-english') {
        translationLanguage = 'english';
    } else if (language === 'qa-ar' || language === 'qa-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'qa-en' || language === 'qa-english') {
        translationLanguage = 'english';
    } else if (language === 'om-ar' || language === 'om-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'om-en' || language === 'om-english') {
        translationLanguage = 'english';
    } else if (language === 'iq-ar' || language === 'iq-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'iq-en' || language === 'iq-english') {
        translationLanguage = 'english';
    } else if (language === 'jo-ar' || language === 'jo-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'jo-en' || language === 'jo-english') {
        translationLanguage = 'english';
    } else if (language === 'lb-ar' || language === 'lb-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'lb-en' || language === 'lb-english') {
        translationLanguage = 'english';
    } else if (language === 'sy-ar' || language === 'sy-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'sy-en' || language === 'sy-english') {
        translationLanguage = 'english';
    } else if (language === 'ps-ar' || language === 'ps-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'ps-en' || language === 'ps-english') {
        translationLanguage = 'english';
    } else if (language === 'ye-ar' || language === 'ye-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'ye-en' || language === 'ye-english') {
        translationLanguage = 'english';
    } else if (language === 'eg-ar' || language === 'eg-arabic') {
        translationLanguage = 'arabic';
    } else if (language === 'eg-en' || language === 'eg-english') {
        translationLanguage = 'english';
    } else if (language === 'pl-pl') {
        translationLanguage = 'polish';
    } else if (language === 'cyprus' || language === 'cy' || language === 'el-cy') {
        translationLanguage = 'greek';
    }

    // Get translations with fallback
    const t = languages[translationLanguage] || languages['english'];
    const [userName, setUserName] = useState('');
    const navigate = useNavigate();

    // Make sure we have translations for all ingredients
    const getIngredientName = (key, defaultName) => {
        return t && t[key] ? t[key] : defaultName;
    };

    // Get translated category name
    const getCategoryName = (category) => {
        const categoryMap = {
            'Beef': 'beef',
            'Breakfast': 'breakfast',
            'Chicken': 'chicken',
            'Dessert': 'dessert',
            'Goat': 'goat',
            'Lamb': 'lamb',
            'Miscellaneous': 'miscellaneous',
            'Pasta': 'pasta',
            'Pork': 'pork',
            'Seafood': 'seafood',
            'Side': 'side',
            'Starter': 'starter',
            'Vegan': 'vegan',
            'Vegetarian': 'vegetarian'
        };
        const translationKey = categoryMap[category];
        return translationKey && t[translationKey] ? t[translationKey] : category;
    };

    // Get translated ingredient name
    const getIngredientTranslatedName = (ingredient) => {
        const ingredientMap = {
            'Chicken': 'chicken',
            'Salmon': 'salmon',
            'Beef': 'beef',
            'Pork': 'pork',
            'Avocado': 'avocado',
            'Apple Cider Vinegar': 'appleCiderVinegar',
            'Asparagus': 'asparagus',
            'Aubergine': 'aubergine',
            'Baby Plum Tomatoes': 'babyPlumTomatoes',
            'Bacon': 'bacon',
            'Baking Powder': 'bakingPowder',
            'Balsamic Vinegar': 'balsamicVinegar',
            'Basil': 'basil',
            'Basil Leaves': 'basilLeaves',
            'Basmati Rice': 'basmatiRice',
            'Bay Leaf': 'bayLeaf',
            'Bay Leaves': 'bayLeaves',
            'Beef Brisket': 'beefBrisket',
            'Beef Fillet': 'beefFillet',
            'Beef Gravy': 'beefGravy',
            'Beef Stock': 'beefStock',
            'Bicarbonate Of Soda': 'bicarbonateOfSoda',
            'Biryani Masala': 'biryaniMasala',
            'Black Pepper': 'blackPepper',
            'Black Treacle': 'blackTreacle'
        };
        const translationKey = ingredientMap[ingredient];
        return translationKey && t[translationKey] ? t[translationKey] : ingredient;
    };

    // Extract unique ingredients from all recipes (moved up for fetchDatabaseRecipes)
    const extractUniqueIngredients = (recipes) => {
        const ingredientMap = new Map();

        recipes.forEach(recipe => {
            if (recipe.ingredients) {
                const ingredients = Array.isArray(recipe.ingredients)
                    ? recipe.ingredients
                    : JSON.parse(recipe.ingredients);

                ingredients.forEach(ingredient => {
                    const name = ingredient.name.toLowerCase().trim();
                    if (name && !ingredientMap.has(name)) {
                        ingredientMap.set(name, ingredient.name); // Keep original casing
                    }
                });
            }
        });

        // Convert to array and sort alphabetically
        return Array.from(ingredientMap.values()).sort((a, b) =>
            a.toLowerCase().localeCompare(b.toLowerCase())
        );
    };

    // Fetch database recipes from Library 1 (moved up for useEffect)
    const fetchDatabaseRecipes = useCallback(async () => {
        try {
            setLoadingDatabaseRecipes(true);
            console.log('Fetching database recipes from Library 1...');

            const response = await axios.get(`${API_BASE_URL}/recipes-by-library/1?language=${language}`);

            if (response.data.success) {
                let recipes = response.data.recipes;
                console.log(`Fetched ${recipes.length} database recipes`);
                
                // Apply halal filter for Arabic-speaking users
                recipes = filterHalalRecipes(recipes, language);
                console.log(`After halal filter: ${recipes.length} recipes`);
                
                setDatabaseRecipes(recipes);

                // Only select 12 random recipes if not already done (prevent re-shuffling on state changes)
                if (randomRecipesRef.current.length === 0) {
                    const shuffled = [...recipes].sort(() => 0.5 - Math.random());
                    const selected = shuffled.slice(0, 12);
                    randomRecipesRef.current = selected; // Store in ref
                    setRandomRecipes(selected);
                    setFilteredDatabaseRecipes(selected);
                    console.log('Selected 12 random recipes for initial display');
                }

                // Extract all unique ingredients from the fetched recipes and filter halal
                const uniqueIngredients = extractUniqueIngredients(recipes);
                const halalIngredients = filterHalalIngredients(uniqueIngredients, language);
                setAvailableIngredients(halalIngredients);
                console.log(`Found ${halalIngredients.length} unique halal ingredients`);
            } else {
                console.error('Failed to fetch database recipes:', response.data.error);
            }
        } catch (error) {
            console.error('Error fetching database recipes:', error);
        } finally {
            setLoadingDatabaseRecipes(false);
        }
    }, [language, API_BASE_URL]);

    // Get translated area name
    const getAreaName = (area) => {
        const areaMap = {
            'American': 'american',
            'British': 'british',
            'Canadian': 'canadian',
            'Chinese': 'chinese',
            'Croatian': 'croatian',
            'Dutch': 'dutch',
            'Egyptian': 'egyptian',
            'Filipino': 'filipino',
            'French': 'french',
            'Greek': 'greek',
            'Indian': 'indian',
            'Irish': 'irish',
            'Italian': 'italian',
            'Jamaican': 'jamaican',
            'Japanese': 'japanese',
            'Kenyan': 'kenyan',
            'Malaysian': 'malaysian',
            'Mexican': 'mexican',
            'Moroccan': 'moroccan',
            'Polish': 'polish',
            'Portuguese': 'portuguese',
            'Russian': 'russian',
            'Spanish': 'spanish',
            'Syrian': 'syrian',
            'Thai': 'thai',
            'Tunisian': 'tunisian',
            'Turkish': 'turkish',
            'Ukrainian': 'ukrainian',
            'Uruguayan': 'uruguayan',
            'Vietnamese': 'vietnamese'
        };
        const translationKey = areaMap[area];
        return translationKey && t[translationKey] ? t[translationKey] : area;
    };

    // Old translate function removed - now using fetchRecipesByLetter batch translation

    const allPopularIngredients = [
        { name: getIngredientName('chicken', 'Chicken'), value: 'chicken', image: Chicken },
        { name: getIngredientName('beef', 'Beef'), value: 'beef', image: Beef },
        { name: getIngredientName('pork', 'Pork'), value: 'pork', image: Pork },
        { name: getIngredientName('salmon', 'Salmon'), value: 'salmon', image: Salmon },
        { name: getIngredientName('shrimp', 'Shrimp'), value: 'shrimp', image: Shrimp },
        { name: getIngredientName('eggs', 'Eggs'), value: 'eggs', image: Eggs },
        { name: getIngredientName('tofu', 'Tofu'), value: 'tofu', image: Tofu },
        { name: getIngredientName('tuna', 'Tuna'), value: 'tuna', image: Tuna },
        { name: getIngredientName('potato', 'Potato'), value: 'potato', image: Potato },
        { name: getIngredientName('rice', 'Rice'), value: 'rice', image: Rice },
    ];

    // Filter out haram ingredients for Arabic-speaking users
    const popularIngredients = filterHalalIngredients(allPopularIngredients, language);

    useEffect(() => {
        const storedUserName = localStorage.getItem('username');
        setUserName(storedUserName || 'Gebruiker');

        // Load persisted allergen preferences from DB
        const userId = localStorage.getItem('userId');
        if (userId) {
            axios.get(`${API_BASE_URL}/user/${userId}/preferences`)
                .then(response => {
                    if (response.data.allergies && response.data.allergies.length > 0) {
                        setDatabaseRecipeFilters(prev => ({
                            ...prev,
                            allergens: response.data.allergies
                        }));
                    }
                })
                .catch(err => console.error('Error loading allergen preferences:', err));
        }
    }, []);

    const handleIngredientClick = (ingredient) => {
        console.log('Navigating with ingredient:', ingredient);
        navigate(`/search?ingredient=${ingredient.value}`);
    };

    const handleCookbookClick = (cookbook) => {
        // For Spanish cookbooks, open the PDF directly
        if (language === 'es' || language === 'spanish') {
            // Check if the cookbook has a PDF URL
            if (cookbook.pdfUrl) {
                // Open the PDF in a new tab
                window.open(cookbook.pdfUrl, '_blank');
                return;
            }
        }

        // For other languages or if no PDF URL is available, use the default behavior
        // Sla het kookboek tijdelijk op in localStorage
        localStorage.setItem('tempAskCookbook', JSON.stringify(cookbook));
        // Navigeer naar de chat
        navigate('/chat');
    };

    useEffect(() => {
        // Prevent double execution in React Strict Mode
        if (hasInitialized.current) return;
        hasInitialized.current = true;

        fetchSavedRecipes();
        fetchCategories();
        fetchIngredients();
        fetchAreas();
        // Old TheMealDB random recipe fetching removed

        // Reset all video filters when loading homepage
        setSelectedLetter(null);
        setSelectedCategory(null);
        setSelectedIngredient(null);
        setSelectedArea(null);
        setFilterType(null);
        setShowRandomRecipes(true);
    }, []);

    // Clear recipes when language changes and fetch new ones
    useEffect(() => {
        // Clear old recipes when language changes
        setRandomRecipes([]);
        randomRecipesRef.current = []; // Clear ref too
        setDatabaseRecipes([]); // Clear database recipes
        setFilteredDatabaseRecipes([]); // Clear filtered recipes
        setRandomRecipeLibraryRecipes([]);

        // Fetch database recipes for the new language
        fetchDatabaseRecipes();
    }, [language]);

    // Filter database recipes when filters change
    useEffect(() => {
        filterDatabaseRecipes();
    }, [databaseRecipeFilters, databaseRecipes, showFilters, sortBy]);

    // Old TheMealDB fetch functions removed - now using fetchRecipesByLetter batch translation

    const applySorting = (recipes) => {
        if (sortBy === 'most_liked') {
            return [...recipes].sort((a, b) => (b.like_count || 0) - (a.like_count || 0));
        }
        if (sortBy === 'most_commented') {
            return [...recipes].sort((a, b) => (b.comment_count || 0) - (a.comment_count || 0));
        }
        if (sortBy === 'newest') {
            return [...recipes].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        }
        if (sortBy === 'calories_low') {
            return [...recipes].sort((a, b) => (a.calories_per_serving || 999) - (b.calories_per_serving || 999));
        }
        if (sortBy === 'quickest') {
            return [...recipes].sort((a, b) => (a.cooking_time || 999) - (b.cooking_time || 999));
        }
        return recipes;
    };

    // Filter database recipes based on current filters
    const filterDatabaseRecipes = useCallback(() => {
        // If filters are not expanded and no search term, show random or sorted recipes
        if (!showFilters && !databaseRecipeFilters.search) {
            if (sortBy !== 'random') {
                setFilteredDatabaseRecipes(applySorting(databaseRecipes));
                return;
            }
            if (randomRecipesRef.current.length > 0) {
                setFilteredDatabaseRecipes(randomRecipesRef.current);
            }
            return;
        }

        // If no filters are active (except showFilters), apply only sorting
        const hasActiveFilters = databaseRecipeFilters.search ||
            databaseRecipeFilters.letter ||
            databaseRecipeFilters.maxCalories !== '1000' ||
            databaseRecipeFilters.maxCookingTime !== '120' ||
            databaseRecipeFilters.minServings !== '1' ||
            databaseRecipeFilters.maxServings !== '12' ||
            databaseRecipeFilters.allergens.length > 0 ||
            databaseRecipeFilters.ingredients.length > 0;

        if (!hasActiveFilters) {
            if (sortBy !== 'random') {
                setFilteredDatabaseRecipes(applySorting(databaseRecipes));
            }
            return;
        }

        let filtered = [...databaseRecipes];

        // Search filter
        if (databaseRecipeFilters.search) {
            const searchTerm = databaseRecipeFilters.search.toLowerCase();
            filtered = filtered.filter(recipe =>
                recipe.name.toLowerCase().includes(searchTerm) ||
                recipe.intro.toLowerCase().includes(searchTerm) ||
                (recipe.ingredients && JSON.stringify(recipe.ingredients).toLowerCase().includes(searchTerm))
            );
        }

        // Letter filter (A-Z)
        if (databaseRecipeFilters.letter) {
            filtered = filtered.filter(recipe =>
                recipe.name.toLowerCase().startsWith(databaseRecipeFilters.letter.toLowerCase())
            );
        }

        // Calories filter
        if (databaseRecipeFilters.maxCalories && parseInt(databaseRecipeFilters.maxCalories) < 1000) {
            const maxCal = parseInt(databaseRecipeFilters.maxCalories);
            filtered = filtered.filter(recipe =>
                recipe.calories_per_serving && recipe.calories_per_serving <= maxCal
            );
        }

        // Cooking time filter
        if (databaseRecipeFilters.maxCookingTime && parseInt(databaseRecipeFilters.maxCookingTime) < 120) {
            const maxTime = parseInt(databaseRecipeFilters.maxCookingTime);
            filtered = filtered.filter(recipe =>
                recipe.cooking_time && recipe.cooking_time <= maxTime
            );
        }

        // Servings filter
        if (databaseRecipeFilters.minServings && parseInt(databaseRecipeFilters.minServings) > 1) {
            const minServings = parseInt(databaseRecipeFilters.minServings);
            filtered = filtered.filter(recipe =>
                recipe.servings && recipe.servings >= minServings
            );
        }

        if (databaseRecipeFilters.maxServings && parseInt(databaseRecipeFilters.maxServings) < 12) {
            const maxServings = parseInt(databaseRecipeFilters.maxServings);
            filtered = filtered.filter(recipe =>
                recipe.servings && recipe.servings <= maxServings
            );
        }

        // Allergens filter -- exclude recipes containing selected allergens
        if (databaseRecipeFilters.allergens.length > 0) {
            filtered = filtered.filter(recipe => {
                const selectedAllergens = databaseRecipeFilters.allergens.map(a => a.toLowerCase());

                // Check explicit allergens field
                if (recipe.allergens) {
                    const recipeAllergens = Array.isArray(recipe.allergens) ? recipe.allergens : JSON.parse(recipe.allergens);
                    if (recipeAllergens.length > 0) {
                        const hasAllergen = selectedAllergens.some(allergen =>
                            recipeAllergens.some(ra => ra.toLowerCase().includes(allergen))
                        );
                        if (hasAllergen) return false;
                    }
                }

                // Also scan ingredient names for allergen keywords
                if (recipe.ingredients) {
                    const ingredients = Array.isArray(recipe.ingredients) ? recipe.ingredients : JSON.parse(recipe.ingredients);
                    const ingredientText = ingredients.map(i => (i.name || i).toLowerCase()).join(' ');
                    if (selectedAllergens.some(allergen => ingredientText.includes(allergen))) {
                        return false;
                    }
                }

                return true;
            });
        }


        // Ingredients filter
        if (databaseRecipeFilters.ingredients.length > 0) {
            filtered = filtered.filter(recipe => {
                if (!recipe.ingredients) return false;
                const recipeIngredients = Array.isArray(recipe.ingredients) ? recipe.ingredients : JSON.parse(recipe.ingredients);

                // Search in the translated ingredient names
                // The ingredients in DB are already translated (e.g., "Kipfilets", "Groene paprika")
                return databaseRecipeFilters.ingredients.some(filterIngredient => {
                    // Get the translated version of the filter ingredient for current language
                    const translatedSearchTerm = getIngredientName(filterIngredient, filterIngredient).toLowerCase();

                    return recipeIngredients.some(recipeIngredient => {
                        const ingredientName = recipeIngredient.name.toLowerCase();
                        // Check if the recipe ingredient contains the translated search term
                        // e.g., "kipfilets" contains "kip" (translated from "chicken")
                        return ingredientName.includes(translatedSearchTerm) ||
                            // Also keep English fallback for backwards compatibility
                            ingredientName.includes(filterIngredient.toLowerCase());
                    });
                });
            });
        }

        setFilteredDatabaseRecipes(applySorting(filtered));
    }, [showFilters, databaseRecipeFilters, databaseRecipes, sortBy]);

    // Update filters and re-filter
    const updateDatabaseRecipeFilter = (key, value) => {
        setDatabaseRecipeFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };

    // Clear all filters
    const clearDatabaseRecipeFilters = () => {
        setDatabaseRecipeFilters({
            search: '',
            letter: '',
            maxCalories: '1000',
            maxCookingTime: '120',
            minServings: '1',
            maxServings: '12',
            allergens: [],
            ingredients: []
        });
    };

    // Show all recipes (without opening filters)
    const showAllRecipes = () => {
        setFilteredDatabaseRecipes(databaseRecipes);
    };

    // Old Recipe Library functions removed - now using fetchRecipesByLetter batch translation

    const fetchSavedRecipes = async () => {
        try {
            const userId = localStorage.getItem('userId');

            const response = await axios.get(`${API_BASE_URL}/saved-recipes/${userId}`);
            setSavedRecipes(response.data);
        } catch (error) {
            console.error('Error fetching saved recipes:', error);
        }
    };

    const handleRecipeClick = (recipe) => {
        setSelectedRecipe(recipe);
        setSelectedImageData(recipe.image_path || recipe.original_image_url || null);
        setIsDetailDialogOpen(true);
    };

    const handleDownloadPdf = async (event, recipe) => {
        event.stopPropagation();
        try {
            await generateRecipePdf(recipe, t);
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };

    const fetchRecipesByLetter = async (letter) => {
        setLoadingRecipes(true);
        setSelectedLetter(letter);
        setSelectedCategory(null);
        setSelectedIngredient(null);
        setSelectedArea(null);
        setFilterType('letter');
        setDisplayedCount(20); // Reset to 20 when selecting new letter
        setShowRandomRecipes(false); // Hide random recipes when filtering
        try {
            const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/search.php?f=${letter}`);
            if (response.data.meals) {
                const validRecipes = response.data.meals.filter(recipe => recipe.strYoutube && recipe.strMealThumb);
                setAllRecipes(validRecipes);
                setRecipesByLetter(validRecipes.slice(0, 20));
            } else {
                setAllRecipes([]);
                setRecipesByLetter([]);
            }
        } catch (error) {
            console.error('Error fetching recipes:', error);
            setAllRecipes([]);
            setRecipesByLetter([]);
        } finally {
            setLoadingRecipes(false);
        }
    };

    const loadMoreRecipes = () => {
        const validRecipes = allRecipes.filter(recipe => recipe.strYoutube && recipe.strMealThumb);
        const newCount = Math.min(displayedCount + 20, validRecipes.length);
        setDisplayedCount(newCount);
        setRecipesByLetter(validRecipes.slice(0, newCount));
    };

    const fetchCategories = async () => {
        try {
            const response = await axios.get('https://www.themealdb.com/api/json/v1/1/list.php?c=list');
            if (response.data.meals) {
                setCategories(response.data.meals);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const fetchIngredients = async () => {
        try {
            const response = await axios.get('https://www.themealdb.com/api/json/v1/1/list.php?i=list');
            if (response.data.meals) {
                // Apply halal filter for Arabic-speaking users
                const filtered = filterHalalIngredients(response.data.meals, language);
                setIngredients(filtered);
            }
        } catch (error) {
            console.error('Error fetching ingredients:', error);
        }
    };

    const fetchAreas = async () => {
        try {
            const response = await axios.get('https://www.themealdb.com/api/json/v1/1/list.php?a=list');
            if (response.data.meals) {
                // Apply halal filter for Arabic-speaking users
                const filtered = filterHalalAreas(response.data.meals, language);
                setAreas(filtered);
            }
        } catch (error) {
            console.error('Error fetching areas:', error);
        }
    };

    const fetchRecipesByCategory = async (category) => {
        setLoadingRecipes(true);
        setSelectedCategory(category);
        setSelectedIngredient(null);
        setSelectedLetter(null);
        setSelectedArea(null);
        setFilterType('category');
        setDisplayedCount(20);
        setShowRandomRecipes(false); // Hide random recipes when filtering
        try {
            const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/filter.php?c=${category}`);
            if (response.data.meals) {
                // Fetch detailed recipe data for each meal
                const detailedRecipes = await Promise.all(
                    response.data.meals.map(async (meal) => {
                        try {
                            const detailResponse = await axios.get(`https://www.themealdb.com/api/json/v1/1/lookup.php?i=${meal.idMeal}`);
                            return detailResponse.data.meals[0];
                        } catch (error) {
                            console.error('Error fetching recipe details:', error);
                            return meal; // Fallback to basic meal data
                        }
                    })
                );
                const validRecipes = detailedRecipes.filter(recipe => recipe.strYoutube && recipe.strMealThumb);
                setAllRecipes(validRecipes);
                setRecipesByLetter(validRecipes.slice(0, 20));
            } else {
                setAllRecipes([]);
                setRecipesByLetter([]);
            }
        } catch (error) {
            console.error('Error fetching recipes by category:', error);
            setAllRecipes([]);
            setRecipesByLetter([]);
        } finally {
            setLoadingRecipes(false);
        }
    };

    const fetchRecipesByIngredient = async (ingredient) => {
        setLoadingRecipes(true);
        setSelectedIngredient(ingredient);
        setSelectedCategory(null);
        setSelectedLetter(null);
        setSelectedArea(null);
        setFilterType('ingredient');
        setDisplayedCount(20);
        setShowRandomRecipes(false); // Hide random recipes when filtering
        try {
            const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/filter.php?i=${ingredient}`);
            if (response.data.meals) {
                // Fetch detailed recipe data for each meal
                const detailedRecipes = await Promise.all(
                    response.data.meals.map(async (meal) => {
                        try {
                            const detailResponse = await axios.get(`https://www.themealdb.com/api/json/v1/1/lookup.php?i=${meal.idMeal}`);
                            return detailResponse.data.meals[0];
                        } catch (error) {
                            console.error('Error fetching recipe details:', error);
                            return meal; // Fallback to basic meal data
                        }
                    })
                );
                const validRecipes = detailedRecipes.filter(recipe => recipe.strYoutube && recipe.strMealThumb);
                setAllRecipes(validRecipes);
                setRecipesByLetter(validRecipes.slice(0, 20));
            } else {
                setAllRecipes([]);
                setRecipesByLetter([]);
            }
        } catch (error) {
            console.error('Error fetching recipes by ingredient:', error);
            setAllRecipes([]);
            setRecipesByLetter([]);
        } finally {
            setLoadingRecipes(false);
        }
    };

    const fetchRecipesByArea = async (area) => {
        setLoadingRecipes(true);
        setSelectedArea(area);
        setSelectedCategory(null);
        setSelectedIngredient(null);
        setSelectedLetter(null);
        setFilterType('area');
        setDisplayedCount(20);
        setShowRandomRecipes(false); // Hide random recipes when filtering
        try {
            const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/filter.php?a=${area}`);
            if (response.data.meals) {
                // Fetch detailed recipe data for each meal
                const detailedRecipes = await Promise.all(
                    response.data.meals.map(async (meal) => {
                        try {
                            const detailResponse = await axios.get(`https://www.themealdb.com/api/json/v1/1/lookup.php?i=${meal.idMeal}`);
                            return detailResponse.data.meals[0];
                        } catch (error) {
                            console.error('Error fetching recipe details:', error);
                            return meal; // Fallback to basic meal data
                        }
                    })
                );
                const validRecipes = detailedRecipes.filter(recipe => recipe.strYoutube && recipe.strMealThumb);
                setAllRecipes(validRecipes);
                setRecipesByLetter(validRecipes.slice(0, 20));
            } else {
                setAllRecipes([]);
                setRecipesByLetter([]);
            }
        } catch (error) {
            console.error('Error fetching recipes by area:', error);
            setAllRecipes([]);
            setRecipesByLetter([]);
        } finally {
            setLoadingRecipes(false);
        }
    };

    const handleYouTubeClick = (youtubeUrl) => {
        if (youtubeUrl) {
            window.open(youtubeUrl, '_blank');
        }
    };

    const handleRecipeLibraryClick = (recipe) => {
        setSelectedRecipeLibrary(recipe);
        setIsRecipeLibraryDialogOpen(true);
    };

    // Old loadMoreRecipeLibraryRecipes function removed - no longer needed

    return (
        <div className={`p-4  min-h-screen ${mcDePageClass(language)}`}>
            {/* Header */}
            <div className="mb-6">
                <Typography variant="h6" color="blue-gray" className={mcDeTheme ? 'mc-de-kicker mb-1' : 'mb-1'}>
                    {mcDeTheme ? getIngredientName('welcomeBack', 'Welcome back') : `👋 ${getIngredientName('welcomeBack', 'Welcome back')}`}
                </Typography>

            </div>

            {/* Need help with a recipe? Card */}
            <Card className={`mb-6 text-white bg-no-repeat bg-right bg-cover ${mcDeTheme ? 'mc-de-hero' : 'bg-green-500'}`} style={{ backgroundImage: `url(${Point})`, backgroundPosition: '75px -30px', zIndex: 5 }}>
                <CardBody className="flex items-center justify-between relative py-10">

                    {/* Pseudo-element via Tailwind voor achtergrond Drop */}
                    <div className="absolute inset-0 bg-no-repeat bg-cover rounded-lg" style={{ backgroundImage: `url(${Drop})`, opacity: 0.1, zIndex: 0 }}></div>

                    {/* Content */}
                    <div className="flex items-center justify-between relative z-10">
                        <div className="flex-1">
                            <Typography variant="h5" className="mb-2">
                                {getIngredientName('needHelpWithRecipe', 'Need help with cooking?')}
                            </Typography>
                            <Link to="/chat">
                                <Typography variant="paragraph" className="text-white cursor-pointer">
                                    {getIngredientName('viewRecipesHome', 'Ask your question')} →
                                </Typography>
                            </Link>
                        </div>
                    </div>

                </CardBody>
            </Card>


            {/* Popular Ingredients */}
            <div className="mb-6">
                <Typography variant="h5" color="blue-gray" className="">
                    {getIngredientName('ingredients', 'Ingredients')}
                </Typography>
                <div className="grid grid-cols-5 gap-4  ">
                    {popularIngredients.map((ingredient, index) => (
                        <div key={index}>
                            <div onClick={() => handleIngredientClick(ingredient)} className="flex flex-col items-center bg-gray-200 rounded-md">
                                <img src={ingredient.image} alt={ingredient.name} className="w-12 h-12 rounded-full " />

                            </div>
                            <Typography variant="small" color="blue-gray" className="text-center">
                                {ingredient.name}
                            </Typography>
                        </div>
                    ))}
                </div>
            </div>


            {/* Video Recipes Browser */}
            {showVideos && (
                <div className="mb-6">
                    <div className="flex items-center gap-2 mb-4">
                        <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z" />
                        </svg>
                        <Typography variant="h5" color="blue-gray">
                            {getIngredientName('videoRecipes', 'Video Recipes')}
                        </Typography>
                    </div>

                    {/* Filter Type Tabs */}
                    <div className="flex flex-wrap gap-2 mb-4">
                        <button
                            onClick={() => setFilterType(filterType === 'letter' ? null : 'letter')}
                            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${filterType === 'letter'
                                ? 'bg-green-500 text-white'
                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                }`}
                        >
                            A-Z
                        </button>
                        <button
                            onClick={() => setFilterType(filterType === 'category' ? null : 'category')}
                            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${filterType === 'category'
                                ? 'bg-green-500 text-white'
                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                }`}
                        >
                            {getIngredientName('categories', 'Categories')}
                        </button>
                        <button
                            onClick={() => setFilterType(filterType === 'ingredient' ? null : 'ingredient')}
                            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${filterType === 'ingredient'
                                ? 'bg-green-500 text-white'
                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                }`}
                        >
                            {getIngredientName('ingredients', 'Ingredients')}
                        </button>
                        <button
                            onClick={() => setFilterType(filterType === 'area' ? null : 'area')}
                            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${filterType === 'area'
                                ? 'bg-green-500 text-white'
                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                }`}
                        >
                            {getIngredientName('areas', 'Areas')}
                        </button>
                    </div>

                    {/* A-Z Letters */}
                    {filterType === 'letter' && (
                        <div className="flex flex-wrap gap-2 mb-4">
                            {Array.from({ length: 26 }, (_, i) => {
                                const letter = String.fromCharCode(65 + i);
                                return (
                                    <button
                                        key={letter}
                                        onClick={() => fetchRecipesByLetter(letter)}
                                        className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${selectedLetter === letter
                                            ? 'bg-green-500 text-white'
                                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                            }`}
                                    >
                                        {letter}
                                    </button>
                                );
                            })}
                        </div>
                    )}

                    {/* Categories */}
                    {filterType === 'category' && (
                        <div className="flex flex-wrap gap-2 mb-4">
                            {categories.slice(0, 15).map((category, index) => (
                                <button
                                    key={index}
                                    onClick={() => fetchRecipesByCategory(category.strCategory)}
                                    className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${selectedCategory === category.strCategory
                                        ? 'bg-green-500 text-white'
                                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                        }`}
                                >
                                    {getCategoryName(category.strCategory)}
                                </button>
                            ))}
                        </div>
                    )}

                    {/* Ingredients */}
                    {filterType === 'ingredient' && (
                        <div className="flex flex-wrap gap-2 mb-4">
                            {ingredients.slice(0, 20).map((ingredient, index) => (
                                <button
                                    key={index}
                                    onClick={() => fetchRecipesByIngredient(ingredient.strIngredient)}
                                    className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${selectedIngredient === ingredient.strIngredient
                                        ? 'bg-green-500 text-white'
                                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                        }`}
                                >
                                    {getIngredientTranslatedName(ingredient.strIngredient)}
                                </button>
                            ))}
                        </div>
                    )}

                    {/* Areas */}
                    {filterType === 'area' && (
                        <div className="flex flex-wrap gap-2 mb-4">
                            {areas.slice(0, 20).map((area, index) => (
                                <button
                                    key={index}
                                    onClick={() => fetchRecipesByArea(area.strArea)}
                                    className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${selectedArea === area.strArea
                                        ? 'bg-green-500 text-white'
                                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                        }`}
                                >
                                    {getAreaName(area.strArea)}
                                </button>
                            ))}
                        </div>
                    )}




                </div>
            )}


            {/* Database Recipes (Library 1) */}
            <div className="mb-6">
                <div className="flex items-center gap-3 mb-4">
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    </svg>
                    <Typography variant="h5" color="blue-gray" className="font-bold text-sm">
                        {t.recipeLibraryTitle || 'Recipe Library'}
                    </Typography>
                    <span className="px-3 py-1 bg-green-100 text-green-700 text-xs font-semibold rounded-full">
                        {(t.recipesCount || '{count} recipes').replace('{count}', databaseRecipes.length)}
                    </span>
                </div>

                {/* Filter Controls */}
                <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl shadow-sm mb-6 border border-gray-200">
                    {/* Search Bar - Always Visible */}
                    <div className="mb-4">
                        <div className="relative">
                            <input
                                type="text"
                                value={databaseRecipeFilters.search}
                                onChange={(e) => updateDatabaseRecipeFilter('search', e.target.value)}
                                placeholder={`${t.searchPlaceholder || 'Search recipes...'}`}
                                className="w-full px-5 py-3 pl-12 text-lg border-2 border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent shadow-sm"
                            />
                            <span className="absolute left-4 top-3.5 text-2xl">🔍</span>
                        </div>
                    </div>

                    {/* Show All Recipes Button - Only visible when filters are collapsed */}
                    {!showFilters && (
                        <button
                            onClick={showAllRecipes}
                            className="w-full mb-4 px-4 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors font-medium shadow-sm flex items-center justify-center gap-2"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                            </svg>
                            {t.viewAllRecipes || 'View All Recipes'}
                        </button>
                    )}

                    {/* Sort Buttons */}
                    <div className="flex flex-wrap gap-2 mb-4">
                        {[
                            { key: 'random', label: `🎲 ${t.random}` },
                            { key: 'most_liked', label: `👍 ${t.mostLiked}` },
                            { key: 'most_commented', label: `💬 ${t.mostCommented}` },
                            { key: 'newest', label: `🆕 ${t.newest}` },
                            { key: 'quickest', label: `⚡ ${t.quickest}` },
                            { key: 'calories_low', label: `🥗 ${t.lowestCalories}` },
                        ].map(opt => (
                            <button
                                key={opt.key}
                                onClick={() => setSortBy(opt.key)}
                                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${sortBy === opt.key
                                    ? 'bg-green-500 text-white shadow-md'
                                    : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
                                }`}
                            >
                                {opt.label}
                            </button>
                        ))}
                    </div>

                    {/* Toggle Filters Button */}
                    <button
                        onClick={() => setShowFilters(!showFilters)}
                        className="w-full mb-4 px-4 py-3 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-800 hover:text-white transition-colors font-medium shadow-sm flex items-center justify-center gap-2"
                    >
                        {showFilters ? (
                            <>
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                </svg>
                                {t.hideFilters || 'Hide Filters'}
                            </>
                        ) : (
                            <>
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                                {t.showFilters || 'Show Filters'}
                            </>
                        )}
                    </button>

                    {showFilters && (
                        <>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
                                {/* Letter Filter Buttons */}
                                <div className="lg:col-span-3">
                                    <label className="block text-sm font-semibold text-gray-700 mb-3">
                                        📝 {t.filterByLetter || 'Filter by Letter'}
                                    </label>
                                    <div className="flex flex-wrap gap-2">
                                        <button
                                            onClick={() => updateDatabaseRecipeFilter('letter', '')}
                                            className={`px-4 py-2 rounded-lg font-medium transition-all ${databaseRecipeFilters.letter === ''
                                                ? 'bg-green-500 text-white shadow-md'
                                                : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
                                                }`}
                                        >
                                            {t.allLetters || 'All'}
                                        </button>
                                        {Array.from({ length: 26 }, (_, i) => {
                                            const letter = String.fromCharCode(65 + i);
                                            return (
                                                <button
                                                    key={letter}
                                                    onClick={() => updateDatabaseRecipeFilter('letter', letter)}
                                                    className={`w-10 h-10 rounded-lg font-bold transition-all ${databaseRecipeFilters.letter === letter
                                                        ? 'bg-green-500 text-white shadow-md scale-110'
                                                        : 'bg-white text-gray-700 hover:bg-gray-100 hover:scale-105 border border-gray-300'
                                                        }`}
                                                >
                                                    {letter}
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Calories Slider */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        🔥 {t.maxCalories || 'Max Calories'}:
                                        <span className="ml-2 text-green-600 font-bold">
                                            {databaseRecipeFilters.maxCalories || 1000} {t.caloriesUnit || 'kcal'}
                                        </span>
                                    </label>
                                    <input
                                        type="range"
                                        min="0"
                                        max="1000"
                                        step="50"
                                        value={databaseRecipeFilters.maxCalories || 1000}
                                        onChange={(e) => updateDatabaseRecipeFilter('maxCalories', e.target.value)}
                                        className="w-full h-3 bg-gray-200 rounded-lg appearance-none cursor-pointer 
                                                   accent-green-500
                                                   [&::-webkit-slider-thumb]:appearance-none 
                                                   [&::-webkit-slider-thumb]:w-5 
                                                   [&::-webkit-slider-thumb]:h-5 
                                                   [&::-webkit-slider-thumb]:rounded-full 
                                                   [&::-webkit-slider-thumb]:bg-green-500 
                                                   [&::-webkit-slider-thumb]:shadow-lg
                                                   [&::-webkit-slider-thumb]:cursor-pointer
                                                   [&::-webkit-slider-thumb]:hover:bg-green-600
                                                   [&::-webkit-slider-thumb]:transition-all
                                                   [&::-moz-range-thumb]:w-5 
                                                   [&::-moz-range-thumb]:h-5 
                                                   [&::-moz-range-thumb]:rounded-full 
                                                   [&::-moz-range-thumb]:bg-green-500 
                                                   [&::-moz-range-thumb]:border-0
                                                   [&::-moz-range-thumb]:shadow-lg
                                                   [&::-moz-range-thumb]:cursor-pointer
                                                   [&::-moz-range-thumb]:hover:bg-green-600
                                                   [&::-moz-range-thumb]:transition-all"
                                    />
                                    <div className="flex justify-between text-xs text-gray-500 mt-1">
                                        <span>0</span>
                                        <span>500</span>
                                        <span>1000</span>
                                    </div>
                                </div>

                                {/* Cooking Time Slider */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        ⏱️ {t.maxCookingTime || 'Max Time'}:
                                        <span className="ml-2 text-green-600 font-bold">
                                            {databaseRecipeFilters.maxCookingTime || 120} {t.minutesUnit || 'min'}
                                        </span>
                                    </label>
                                    <input
                                        type="range"
                                        min="0"
                                        max="120"
                                        step="5"
                                        value={databaseRecipeFilters.maxCookingTime || 120}
                                        onChange={(e) => updateDatabaseRecipeFilter('maxCookingTime', e.target.value)}
                                        className="w-full h-3 bg-gray-200 rounded-lg appearance-none cursor-pointer 
                                                   accent-green-500
                                                   [&::-webkit-slider-thumb]:appearance-none 
                                                   [&::-webkit-slider-thumb]:w-5 
                                                   [&::-webkit-slider-thumb]:h-5 
                                                   [&::-webkit-slider-thumb]:rounded-full 
                                                   [&::-webkit-slider-thumb]:bg-green-500 
                                                   [&::-webkit-slider-thumb]:shadow-lg
                                                   [&::-webkit-slider-thumb]:cursor-pointer
                                                   [&::-webkit-slider-thumb]:hover:bg-green-600
                                                   [&::-webkit-slider-thumb]:transition-all
                                                   [&::-moz-range-thumb]:w-5 
                                                   [&::-moz-range-thumb]:h-5 
                                                   [&::-moz-range-thumb]:rounded-full 
                                                   [&::-moz-range-thumb]:bg-green-500 
                                                   [&::-moz-range-thumb]:border-0
                                                   [&::-moz-range-thumb]:shadow-lg
                                                   [&::-moz-range-thumb]:cursor-pointer
                                                   [&::-moz-range-thumb]:hover:bg-green-600
                                                   [&::-moz-range-thumb]:transition-all"
                                    />
                                    <div className="flex justify-between text-xs text-gray-500 mt-1">
                                        <span>0</span>
                                        <span>60</span>
                                        <span>120</span>
                                    </div>
                                </div>

                                {/* Servings Dual Range Slider */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        👥 {t.servings}:
                                        <span className="ml-2 text-green-600 font-bold">
                                            {databaseRecipeFilters.minServings || 1} - {databaseRecipeFilters.maxServings || 12}
                                        </span>
                                    </label>
                                    {(() => {
                                        const min = parseInt(databaseRecipeFilters.minServings) || 1;
                                        const max = parseInt(databaseRecipeFilters.maxServings) || 12;
                                        const leftPct = ((min - 1) / 11) * 100;
                                        const rightPct = ((max - 1) / 11) * 100;
                                        const thumbCss = `w-full absolute top-0 h-3 appearance-none bg-transparent cursor-pointer pointer-events-none
                                                       [&::-webkit-slider-thumb]:appearance-none 
                                                       [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:h-5 
                                                       [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-green-500 
                                                       [&::-webkit-slider-thumb]:shadow-lg [&::-webkit-slider-thumb]:cursor-pointer
                                                       [&::-webkit-slider-thumb]:pointer-events-auto
                                                       [&::-webkit-slider-thumb]:hover:bg-green-600 [&::-webkit-slider-thumb]:transition-all
                                                       [&::-moz-range-thumb]:w-5 [&::-moz-range-thumb]:h-5 
                                                       [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-green-500 
                                                       [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:shadow-lg
                                                       [&::-moz-range-thumb]:cursor-pointer [&::-moz-range-thumb]:pointer-events-auto
                                                       [&::-moz-range-thumb]:hover:bg-green-600 [&::-moz-range-thumb]:transition-all`;
                                        return (
                                            <div className="relative h-3">
                                                <div className="absolute w-full h-3 bg-gray-200 rounded-lg" />
                                                <div
                                                    className="absolute h-3 bg-green-400 rounded-lg"
                                                    style={{ left: `${leftPct}%`, width: `${rightPct - leftPct}%` }}
                                                />
                                                <input
                                                    type="range" min="1" max="12" step="1" value={min}
                                                    onChange={(e) => {
                                                        const v = Math.min(parseInt(e.target.value), max);
                                                        updateDatabaseRecipeFilter('minServings', String(v));
                                                    }}
                                                    className={thumbCss}
                                                    style={{ zIndex: min > 6 ? 5 : 3 }}
                                                />
                                                <input
                                                    type="range" min="1" max="12" step="1" value={max}
                                                    onChange={(e) => {
                                                        const v = Math.max(parseInt(e.target.value), min);
                                                        updateDatabaseRecipeFilter('maxServings', String(v));
                                                    }}
                                                    className={thumbCss}
                                                    style={{ zIndex: max < 6 ? 5 : 4 }}
                                                />
                                            </div>
                                        );
                                    })()}
                                    <div className="flex justify-between text-xs text-gray-500 mt-2">
                                        <span>1</span>
                                        <span>6</span>
                                        <span>12</span>
                                    </div>
                                </div>

                                {/* Allergens Multi-Select */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        ⚠️ {t.selectAllergens}
                                    </label>
                                    <div className="flex flex-wrap gap-2">
                                        {[
                                            { key: 'gluten', label: `🌾 ${getIngredientName('gluten', 'gluten')}` },
                                            { key: 'dairy', label: `🧈 ${getIngredientName('dairy', 'dairy')}` },
                                            { key: 'lactose', label: `🥛 ${getIngredientName('lactose', 'lactose')}` },
                                            { key: 'nuts', label: `🥜 ${getIngredientName('nuts', 'nuts')}` },
                                            { key: 'eggs', label: `🥚 ${getIngredientName('eggs', 'eggs')}` },
                                            { key: 'soy', label: `🫘 ${getIngredientName('soy', 'soy')}` },
                                            { key: 'fish', label: `🐟 ${getIngredientName('fish', 'fish')}` },
                                            { key: 'shellfish', label: `🦐 ${getIngredientName('shellfish', 'shellfish')}` },
                                            { key: 'peanuts', label: `🥜 ${getIngredientName('peanuts', 'peanuts')}` },
                                            { key: 'sesame', label: `🫘 ${getIngredientName('sesame', 'sesame')}` },
                                            { key: 'celery', label: `🥬 ${getIngredientName('celery', 'celery')}` },
                                            { key: 'mustard', label: `🌭 ${getIngredientName('mustard', 'mustard')}` },
                                            { key: 'sulphites', label: `🧪 ${getIngredientName('sulphites', 'sulphites')}` },
                                            { key: 'lupin', label: `🌸 ${getIngredientName('lupin', 'lupin')}` },
                                            { key: 'molluscs', label: `🐚 ${getIngredientName('molluscs', 'molluscs')}` },
                                        ].map(allergen => (
                                            <button
                                                key={allergen.key}
                                                onClick={() => {
                                                    const current = databaseRecipeFilters.allergens;
                                                    if (current.includes(allergen.key)) {
                                                        updateDatabaseRecipeFilter('allergens', current.filter(a => a !== allergen.key));
                                                    } else {
                                                        updateDatabaseRecipeFilter('allergens', [...current, allergen.key]);
                                                    }
                                                }}
                                                className={`px-3 py-1 rounded-full text-xs font-medium transition-all ${databaseRecipeFilters.allergens.includes(allergen.key)
                                                    ? 'bg-yellow-500 text-white shadow-md'
                                                    : 'bg-white text-gray-700 border border-gray-300 hover:bg-yellow-50'
                                                    }`}
                                            >
                                                {allergen.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                {/* Ingredients Multi-Select */}
                                <div className="lg:col-span-2">
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        🥕 {t.selectIngredients || 'Select Ingredients'}
                                        <span className="ml-2 text-xs text-gray-500">
                                            ({availableIngredients.length} {t.allLetters?.toLowerCase() || 'available'})
                                        </span>
                                    </label>
                                    <div className="relative">
                                        <input
                                            type="text"
                                            value={databaseRecipeFilters.ingredients.join(', ')}
                                            onChange={(e) => updateDatabaseRecipeFilter('ingredients', e.target.value.split(',').map(i => i.trim()).filter(i => i))}
                                            placeholder={t.typeToSearch || 'Type to search...'}
                                            className="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                        />
                                    </div>
                                    <div className="mt-2 max-h-40 overflow-y-auto bg-white border border-gray-200 rounded-lg p-2">
                                        <div className="flex flex-wrap gap-1">
                                            {availableIngredients.map(ingredient => {
                                                const ingredientLower = ingredient.toLowerCase();
                                                const isSelected = databaseRecipeFilters.ingredients.some(
                                                    selected => ingredient.toLowerCase().includes(selected.toLowerCase())
                                                );

                                                return (
                                                    <button
                                                        key={ingredientLower}
                                                        onClick={() => {
                                                            const current = databaseRecipeFilters.ingredients;
                                                            if (isSelected) {
                                                                // Remove any ingredient that matches
                                                                updateDatabaseRecipeFilter('ingredients',
                                                                    current.filter(i => !ingredientLower.includes(i.toLowerCase()))
                                                                );
                                                            } else {
                                                                updateDatabaseRecipeFilter('ingredients', [...current, ingredient]);
                                                            }
                                                        }}
                                                        className={`px-2 py-1 rounded-full text-xs font-medium transition-all ${isSelected
                                                            ? 'bg-orange-500 text-white shadow-sm'
                                                            : 'bg-gray-100 text-gray-700 hover:bg-orange-50 border border-gray-300'
                                                            }`}
                                                        title={ingredient}
                                                    >
                                                        {ingredient}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Clear Filters Button */}
                            <div className="flex justify-between items-center pt-4 border-t border-gray-300">
                                <div className="text-sm text-gray-600">
                                    {filteredDatabaseRecipes.length} {(t.recipesCount || '{count} recipes').replace('{count}', '')}
                                </div>
                                <button
                                    onClick={clearDatabaseRecipeFilters}
                                    className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-medium shadow-sm"
                                >
                                    🗑️ {t.clearFilters || 'Clear Filters'}
                                </button>
                            </div>
                        </>
                    )}
                </div>

                {/* Loading State */}
                {loadingDatabaseRecipes ? (
                    <div className="text-center py-8">
                        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-green-500"></div>
                        <p className="mt-2 text-gray-600">{getIngredientName('loading', 'Loading...')}</p>
                    </div>
                ) : filteredDatabaseRecipes.length === 0 ? (
                    <div className="text-center py-12">
                        <svg className="w-16 h-16 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p className="text-gray-600 text-lg">{t.noRecipesMatch || 'No recipes match the filters'}</p>
                    </div>
                ) : (
                    /* Recipe Grid */
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {filteredDatabaseRecipes.map((recipe, index) => {
                            const ingredients = Array.isArray(recipe.ingredients) ? recipe.ingredients : JSON.parse(recipe.ingredients || '[]');
                            const allergens = Array.isArray(recipe.allergens) ? recipe.allergens : JSON.parse(recipe.allergens || '[]');

                            return (
                                <Card
                                    key={index}
                                    className="overflow-hidden cursor-pointer hover:shadow-lg transition-shadow flex flex-col"
                                    onClick={() => {
                                        setSelectedRecipe(recipe);
                                        setIsDetailDialogOpen(true);
                                    }}
                                >
                                    <div className="relative">
                                        {recipe.image_path ? (
                                            <img
                                                src={resolveImageUrl(recipe.image_path)}
                                                alt={recipe.name}
                                                className="w-full h-48 object-cover"
                                            />
                                        ) : (
                                            <div className="w-full h-48 bg-gray-200 flex items-center justify-center">
                                                <span className="text-gray-500">No Image</span>
                                            </div>
                                        )}

                                        {/* Download button - top left */}
                                        <div className="absolute top-2 left-2">
                                            <IconButton
                                                color="white"
                                                size="sm"
                                                variant="filled"
                                                className="rounded-full shadow-md"
                                                onClick={(e) => handleDownloadPdf(e, recipe)}
                                            >
                                                <ArrowDownTrayIcon className="h-4 w-4 text-gray-700" />
                                            </IconButton>
                                        </div>
                                        {/* Calories & cooking time - top right */}
                                        <div className="absolute top-2 right-2 flex gap-1">
                                            {recipe.calories_per_serving && (
                                                <span className="bg-red-500 text-white px-2 py-1 rounded-full text-xs flex items-center">
                                                    🔥 {recipe.calories_per_serving} cal
                                                </span>
                                            )}
                                            {recipe.cooking_time && (
                                                <span className="bg-green-500 text-white px-2 py-1 rounded-full text-xs flex items-center">
                                                    ⏱️ {recipe.cooking_time} min
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    <CardBody className="p-4 flex flex-col flex-1">
                                        <Typography variant="h6" color="blue-gray" className="mb-2">
                                            {recipe.name}
                                        </Typography>

                                        <Typography variant="small" color="gray" className="mb-3 line-clamp-2">
                                            {recipe.intro}
                                        </Typography>

                                        {/* Recipe Meta */}
                                        <div className="flex flex-wrap gap-2 mb-3">
                                            {recipe.servings && (
                                                <span className="bg-gray-100 text-gray-600 px-2 py-1 rounded-full text-xs">
                                                    👥 {recipe.servings} {getIngredientName('servings', 'servings')}
                                                </span>
                                            )}
                                            {allergens.length > 0 && (
                                                <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full text-xs">
                                                    ⚠️ {allergens.slice(0, 2).join(', ')}
                                                    {allergens.length > 2 && ` +${allergens.length - 2}`}
                                                </span>
                                            )}
                                        </div>

                                        {/* Ingredients Preview */}
                                        {ingredients.length > 0 && (
                                            <div className="mb-3">
                                                <Typography variant="small" color="gray" className="mb-1">
                                                    {getIngredientName('ingredients', 'Ingredients')}:
                                                </Typography>
                                                <div className="flex flex-wrap gap-1">
                                                    {ingredients.slice(0, 3).map((ingredient, idx) => (
                                                        <span key={idx} className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs">
                                                            {ingredient.name}
                                                        </span>
                                                    ))}
                                                    {ingredients.length > 3 && (
                                                        <span className="bg-gray-100 text-gray-600 px-2 py-1 rounded-full text-xs">
                                                            +{ingredients.length - 3} more
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {/* Spacer pushes likes/comments to bottom */}
                                        <div className="flex-1" />

                                        {/* Likes & Comments - pinned bottom right */}
                                        <div className="flex items-center justify-end gap-3 text-gray-400 text-xs pt-2 border-t border-gray-100">
                                            <span className="flex items-center gap-1">
                                                👍 {recipe.like_count || 0}
                                            </span>
                                            <span className="flex items-center gap-1">
                                                💬 {recipe.comment_count || 0}
                                            </span>
                                        </div>

                                    </CardBody>
                                </Card>
                            );
                        })}
                    </div>
                )}


            </div>

            {/* Popular Cookbooks */}
            <div className="mb-6">
                <div className="flex justify-between items-center mb-4">
                    <Typography variant="h5" color="blue-gray">
                        {getIngredientName('popularCookbooks', 'Popular Cookbooks')}
                    </Typography>

                </div>
                <div className="flex overflow-x-auto gap-4 pb-4 hide-scrollbar">
                    {/* Display Spanish cookbooks when language is Spanish, otherwise show default cookbooks */}
                    {(language === 'es' || language === 'spanish' ? spanishCookbooks : popularCookbooks).map((cookbook, index) => (
                        <Card
                            key={index}
                            className="w-48 shrink-0 cursor-pointer"
                            onClick={() => handleCookbookClick(cookbook)}
                        >
                            <CardBody className="p-0 flex flex-col justify-between">
                                <img src={cookbook.image} alt={cookbook.name} className="w-full h-48 object-cover" />
                                <div className="p-4">
                                    <Typography variant="h6" color="blue-gray" className="mb-2">
                                        {cookbook.name}
                                    </Typography>
                                    <Typography variant="small" color="gray" className="mb-2">
                                        {cookbook.author}
                                    </Typography>
                                </div>
                            </CardBody>
                        </Card>
                    ))}

                </div>
            </div>

            {selectedRecipe && (
                <RecipeDetail
                    recipe={selectedRecipe}
                    isOpen={isDetailDialogOpen}
                    onClose={() => setIsDetailDialogOpen(false)}
                    imageData={selectedImageData}
                />
            )}

            <style jsx="true">{`
                .hide-scrollbar::-webkit-scrollbar {
                    display: none;
                }
                .hide-scrollbar {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                .line-clamp-2 {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            `}</style>
        </div>
    );
};

export default Home;
